const N=v=>v==null||v===''?null:Number.isFinite(Number(v))?Number(v):null;
const pct=(a,b)=>a!=null&&b!=null&&b!==0?(a/b-1)*100:null;

function priceState(v){
 if(v==null)return'MISSING';
 if(v>=10)return'UP_STRONG';
 if(v>=5)return'UP';
 if(v<=-10)return'DOWN_STRONG';
 if(v<=-5)return'DOWN';
 return'FLAT';
}
function revisionState(e7,e30){
 if(e7==null&&e30==null)return'MISSING';
 if((e7!=null&&e7>=3)||(e30!=null&&e30>=5))return'UP';
 if((e7!=null&&e7<=-3)||(e30!=null&&e30<=-5))return'DOWN';
 return'STABLE';
}

export function deriveRocketEvidence(bundle={}){
 const rows=Array.isArray(bundle?.market?.rows)?bundle.market.rows:[];
 const current=N(rows[0]?.close??bundle?.market?.price),prior20=N(rows[20]?.close);
 const price20dPct=pct(current,prior20);
 const epsRevision7dPct=N(bundle?.consensus?.diagnostics?.epsRevision7dPct);
 const epsRevision30dPct=N(bundle?.consensus?.diagnostics?.epsRevision30dPct);
 const pState=priceState(price20dPct),rState=revisionState(epsRevision7dPct,epsRevision30dPct);

 let state='MISSING',intensity='MISSING';
 if(pState!=='MISSING'||rState!=='MISSING'){
  state='QUIET';intensity='LOW';
  const pUp=['UP','UP_STRONG'].includes(pState),pDown=['DOWN','DOWN_STRONG'].includes(pState);
  if(pUp&&rState==='UP'){state='POSITIVE_REPRICING';intensity=pState==='UP_STRONG'?'HIGH':'MEDIUM'}
  else if(pDown&&rState==='DOWN'){state='NEGATIVE_REPRICING';intensity=pState==='DOWN_STRONG'?'HIGH':'MEDIUM'}
  else if(rState==='UP'&&!pUp){state='POSITIVE_REVISION_DIVERGENCE';intensity='MEDIUM'}
  else if(rState==='DOWN'&&!pDown){state='NEGATIVE_REVISION_DIVERGENCE';intensity='MEDIUM'}
  else if(rState==='MISSING'&&(pUp||pDown)){state='PRICE_ONLY';intensity=pState.endsWith('STRONG')?'HIGH':'MEDIUM'}
  else if(pState==='MISSING'&&['UP','DOWN'].includes(rState)){state='REVISION_ONLY';intensity='MEDIUM'}
 }

 return{
  status:state==='MISSING'?'MISSING':'EVIDENCE',
  state,
  intensity,
  price20dPct,
  priceState:pState,
  epsRevision7dPct,
  epsRevision30dPct,
  revisionState:rState,
  thresholds:{priceMovePct:5,strongPriceMovePct:10,eps7dPct:3,eps30dPct:5},
  note:'Rocket measures repricing pressure from verified price movement and forward EPS estimate revisions. It does not claim valuation-multiple expansion because historical valuation-multiple evidence is not currently available.'
 };
}
